"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closestPointOnLineSegment = exports.toDegrees = exports.LinePointIndex = void 0;
/** Represents a point on a line segment, containing both the point in 3D space and the
 * ratio between two supplied points (in the range [0..1]).
 */
var LinePointIndex = /** @class */ (function () {
    function LinePointIndex(ratio, point) {
        this.ratio = ratio;
        this.point = point;
    }
    return LinePointIndex;
}());
exports.LinePointIndex = LinePointIndex;
/** Convert radians to degrees. */
function toDegrees(radians) {
    return radians * (180 / Math.PI);
}
exports.toDegrees = toDegrees;
/** Returns the closest the point on line segment to a reference point.
 * @param linePoint1 - The starting point of the line segment.
 * @param linePoint2 - The ending point of the line segment.
 * @param referencePoint - The reference point to which the closest point will be found.
 * @returns - An initialized class that contains both the closest point in 3D space, and the ratio between linePoint1 and linePoint2 at which it was found
 * (in the range [0..1]).
 */
function closestPointOnLineSegment(linePoint1, linePoint2, referencePoint) {
    var a = linePoint1;
    var b = linePoint2;
    var p = referencePoint;
    var AB = b.subtract(a);
    var AP = p.subtract(a);
    // The dot product is the squared length of AB projected onto AP.
    var apDotAb = AP.dot(AB);
    if (apDotAb <= 0) {
        return new LinePointIndex(0, linePoint1);
    }
    // this is equivalent to AB x AB
    // which is equivalent to the length of AB squared
    var abSquared = AB.dot(AB);
    if (abSquared <= apDotAb) {
        return new LinePointIndex(1, linePoint2);
    }
    // The ratio is how much of AB we want to keep.
    // you could square root them both to get true lengths but why bother.
    var ratio = apDotAb / abSquared;
    var closest = a.add(AB.multiplyByScalar(ratio));
    return new LinePointIndex(ratio, closest);
}
exports.closestPointOnLineSegment = closestPointOnLineSegment;
//# sourceMappingURL=Math3D.js.map